/* eslint-disable import/no-default-export */
import {controllerFactory} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/controller-factory/controllerFactory';
import {ProductPageController} from '../../productPage/viewerScript/ProductPageController';
import {OldProductPageController} from '../../productPage/viewerScript/OldProductPageController';
import {SPECS} from '../../productPage/specs';
import {ConditionalController} from '@wix/wixstores-client-storefront-common';

export default ConditionalController(
  SPECS.RemoveControllerFactory,
  ProductPageController,
  controllerFactory(OldProductPageController)
);
